import {
    PRODUCER_COMP_PERIODS, GET_PRODUCER_NUMBER, UPDATE_PRODUCER_NUMBER, PRODUCER_USERS,
    GET_PRODUCER_LOB_LIST, CREATE_PRODUCER_LOB, UPDATE_PRODUCER_LOB, DELETE_PRODUCER_LOB,
    GET_PACKAGE_CATEGORY_LIST, CREATE_PACKAGE_CATEGORY, 
    UPDATE_PACKAGE_CATEGORY, DELETE_PACKAGE_CATEGORY, 
    GET_PACKAGE_NAME_LIST, CREATE_PACKAGE_NAME, UPDATE_PACKAGE_NAME, DELETE_PACKAGE_NAME,
    GET_PACKAGE_FULL_LIST, GET_PACKAGES, CREATE_PACKAGE, UPDATE_PACKAGE, DELETE_PACKAGE,
    GET_CONDITIONS, CREATE_CONDITION, UPDATE_CONDITION, DELETE_CONDITION,
    GET_ASSIGNED_PACKAGES, ASSIGN_PACKAGE, UPDATE_ASSIGNED_PACKAGE, DELETE_ASSIGNED_PACKAGE,
    GET_PRODUCER_SETTING, UPADTE_PRODUCER_SETTING
} from './../actions/ActionTypes';
import InitialState from './InitialState';

const ProducerReducer = (state = InitialState.producer, action) => {

    const compareLobName = (a, b) => {
        if (a.lob.toUpperCase() < b.lob.toUpperCase()) {
            return -1;
        }
        if (a.lob.toUpperCase() > b.lob.toUpperCase()) {
            return 1;
        }
        return 0;
    }

    const compareCategoryName = (a, b) => {
        if (a.category.toUpperCase() < b.category.toUpperCase()) {
            return -1;
        }
        if (a.category.toUpperCase() > b.category.toUpperCase()) {
            return 1;
        }
        return 0;
    }

    const comparePackage = (a, b) => {
        if (a.row_order < b.row_order) {
            return -1;
        }
        if (a.row_order > b.row_order) {
            return 1;
        }
        if (a.column_order < b.column_order) {
            return -1;
        }
        if (a.column_order > b.column_order) {
            return 1;
        }
        return 0;
    }

    const comparePackageName = (a, b) => {
        if (a.name.toUpperCase() < b.name.toUpperCase()) {
            return -1;
        }
        if (a.name.toUpperCase() > b.name.toUpperCase()) {
            return 1;
        }
        return 0;
    }
    
    switch (action.type) {
        case PRODUCER_USERS: {
            return {
                ...state,
                userList: action.response
            }
        }
        case PRODUCER_COMP_PERIODS: {
            return {
                ...state,
                periods: action.response
            }
        }
        case GET_PRODUCER_SETTING: 
        case UPADTE_PRODUCER_SETTING: {
            return {...state, settings: action.response}
        }
        case GET_PRODUCER_NUMBER: 
        case UPDATE_PRODUCER_NUMBER: {
            return {...state, numbers: action.response}
        }
        case GET_PRODUCER_LOB_LIST: {
            return {
                ...state,
                lobList: action.response
            }
        }
        case CREATE_PRODUCER_LOB: {
            let newList = [...state.lobList];
            if (action.response.id) {
                newList.push({...action.response})
            }
            newList.sort(compareLobName);
            return {
                ...state,
                lobList: newList,
            }
        }
        case UPDATE_PRODUCER_LOB: {
            let newList = state.lobList.map(lob => {
                if (lob.id === action.response.id) {
                    return {...action.response}
                }
                return {...lob}
            });
            newList.sort(compareLobName);

            return {
                ...state,
                lobList: newList
            }
        }
        case DELETE_PRODUCER_LOB: {
            let newList = state.lobList.filter(lob => 
                lob.id !== action.lob.id
            );

            return {
                ...state,
                lobList: newList
            }
        }
        case GET_PACKAGE_CATEGORY_LIST: {
            return {
                ...state,
                categoryList: action.response
            }
        }
        case CREATE_PACKAGE_CATEGORY: {
            let newList = [...state.categoryList];
            if (action.response.id) {
                newList.push({...action.response})
            }
            newList.sort(compareCategoryName);
            return {
                ...state,
                categoryList: newList,
            }
        }
        case UPDATE_PACKAGE_CATEGORY: {
            let newList = state.categoryList.map(category => {
                if (category.id === action.response.id) {
                    return {...action.response}
                }
                return {...category}
            });
            newList.sort(compareCategoryName);

            return {
                ...state,
                categoryList: newList
            }
        }
        case DELETE_PACKAGE_CATEGORY: {
            let newList = state.categoryList.filter(category => 
                category.id !== action.category.id
            );

            return {
                ...state,
                categoryList: newList
            }
        }
        case GET_PACKAGE_NAME_LIST: {
            return {
                ...state,
                packageMasterList: action.response
            }
        }
        case CREATE_PACKAGE_NAME: {
            let newList = [...state.packageMasterList];
            if (action.response.id) {
                newList.push({...action.response})
            }
            newList.sort(comparePackageName);
            return {
                ...state,
                packageMasterList: newList,
            }
        }
        case UPDATE_PACKAGE_NAME: {
            let newList = state.packageMasterList.map(packageObj => {
                if (packageObj.id === action.response.id) {
                    return {...action.response}
                }
                return {...packageObj}
            });
            newList.sort(comparePackageName);

            return {
                ...state,
                packageMasterList: newList
            }
        }
        case DELETE_PACKAGE_NAME: {
            let newList = state.packageMasterList.filter(packageObj => 
                packageObj.id !== action.package.id
            );

            return {
                ...state,
                packageMasterList: newList
            }
        }
        case GET_PACKAGE_FULL_LIST: {
            return {
                ...state,
                packageMasterFullList: action.response
            }
        }
        case GET_PACKAGES: {
            return {
                ...state,
                packageList: action.response
            }
        }
        case CREATE_PACKAGE: {
            let newList = [...state.packageList];
            if (action.response.id) {
                newList.push({...action.response})
            }
            newList.sort(comparePackage);
            return {
                ...state,
                packageList: newList,
            }
        }
        case UPDATE_PACKAGE: {
            let newList = state.packageList.map(packageObj => {
                if (packageObj.id === action.response.id) {
                    return {...action.response}
                }
                return {...packageObj}
            });
            newList.sort(comparePackage);

            return {
                ...state, 
                packageList: newList
            }
        }
        case DELETE_PACKAGE: {
            let newList = state.packageList.filter(packageObj => 
                packageObj.id !== action.package.id
            );

            return {
                ...state, 
                packageList: newList
            }
        }
        case GET_CONDITIONS: {
            return {
                ...state,
                conditionList: action.response
            }
        }
        case CREATE_CONDITION: {
            let newList = [...state.conditionList];
            if (action.response.id) {
                newList.push({...action.response})
            }
            return {
                ...state,
                conditionList: newList,
            }
        }
        case UPDATE_CONDITION: {
            let newList = state.conditionList.map(conditionObj => {
                if (conditionObj.id === action.response.id) {
                    return {...action.response}
                }
                return {...conditionObj}
            });

            return {
                ...state, 
                conditionList: newList
            }
        }
        case DELETE_CONDITION: {
            let newList = state.conditionList.filter(conditionObj => 
                conditionObj.id !== action.condition.id
            );

            return {
                ...state, 
                conditionList: newList
            }
        }
        case GET_ASSIGNED_PACKAGES: {
            return {
                ...state,
                assignedPackageList: action.response
            }
        }
        case ASSIGN_PACKAGE: {
            let newList = [...state.assignedPackageList];
            if (action.response.id) {
                newList.push({...action.response})
            }
            
            return {
                ...state,
                assignedPackageList: newList,
            }
        }
        case UPDATE_ASSIGNED_PACKAGE: {
            let newList = state.assignedPackageList.map(packageObj => {
                if (packageObj.id === action.response.id) {
                    return {...action.response}
                }
                return {...packageObj}
            });

            return {
                ...state, 
                assignedPackageList: newList
            }
        }
        case DELETE_ASSIGNED_PACKAGE: {
            let newList = state.assignedPackageList.filter(packageObj => 
                packageObj.id !== action.package.id
            );

            return {
                ...state, 
                assignedPackageList: newList
            }
        }
        default:
            return state;
    }

};

export default ProducerReducer;



// WEBPACK FOOTER //
// ./src/reducers/ProducerReducer.js